import {useMutation, type UseMutationOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {riskSurveyQueries} from '../../api'
import type {ImportDuplicateCheckRequest, ImportDuplicateCheckResponseDto} from '../../types'

export const useImportDuplicateCheck = (
  options?: UseMutationOptions<
    ImportDuplicateCheckResponseDto,
    AxiosError,
    ImportDuplicateCheckRequest
  >
) => {
  return useMutation<ImportDuplicateCheckResponseDto, AxiosError, ImportDuplicateCheckRequest>({
    mutationFn: (data) => riskSurveyQueries.checkImportDuplicate(data),
    ...options
  })
}
